/**
 * 系统设置，非环境变量配置，但依赖于环境变量
 * @creator francklin
 * @created 2021.09.13
 */

export default {
  // 公共
  common: {

  },
  // 开发
  dev: {

  },
  // 测试
  test: {

  },
  // 预发
  pre: {

  },
  // 边锋
  edge: {

  },
  // 生产
  prod: {

  }
}
